import React from "react";
import { Grid, Typography } from "@mui/material/";
import { strings } from "../../../../common/i18n";

export default ({ foundElsewhere }) => {
    const { assetAuditedNote } = foundElsewhere;
    const noteAccount = assetAuditedNote?.accountKey
        ? strings(assetAuditedNote.accountKey)
        : assetAuditedNote?.account;
    return (
        <>
            {noteAccount && assetAuditedNote?.note && (
                <Grid>
                    <Typography variant="subtitle2" m={2} component="p">
                        {`${noteAccount} ${strings(
                            "excludedAssetFor"
                        )} ${assetAuditedNote.exclusionReason ?? ""}`}
                    </Typography>
                    <Typography variant="subtitle2" m={2} component="p">
                        {`${strings("note")}: ${assetAuditedNote.note}`}
                    </Typography>
                </Grid>
            )}
            <Typography
                variant="h6"
                color="primary"
                m={2}
                textTransform="uppercase"
            >
                {strings("assetFoundElsewhere")}
            </Typography>
        </>
    );
};
